import * as OfflinePluginRuntime from 'offline-plugin/runtime';

/**
 * Installs the update service worker (from offline-plugin) and resolves the
 * promise.
 * @return {Promise.<void>}
 */
export function install() {
    OfflinePluginRuntime.install();
    return Promise.resolve();
}



// WEBPACK FOOTER //
// ./src/shared/childupp-auto-update/browser-auto-update.js